import { type ReactNode, useState, useEffect } from 'react';
import { AlertPopupContainer } from './alertPopup.styled';

import Heading from '../typography';
import { lockScroll, unlockScroll } from '../../utils/modalScrollManager';
import useModalScrollLock from '../../hooks/custom-hooks/useModalScrollLock';
import Button from '../button';
import { Transition } from 'react-transition-group';
import { FormWrapper } from '../input-text/input.styled';
import { isEmpty } from 'lodash';
import { COLORS } from '../../constants/style/color';

interface AlertPopupType {
  isShow: boolean;
  closeModal?: () => void;
  handleSubmit?: any;
  title?: string | ReactNode;
  ConfirmTitle?: string | ReactNode;
  modalStatus?: string | ReactNode;
  setRemark?: any;
  remark?: any;
  loading?: boolean;
  customTitle?: string | ReactNode;
  width?: string;
  display?: boolean;
  showTaskReferenceNo?: boolean;
  dynamicReport?: boolean;
  icon?: boolean;
  taskRefrenceNo?: string;
  subTitle?: any;
  subTitleMaxHeight?: string;
  id?: string;
  center?: boolean;
  showCloseButton?: boolean;
  onClose?: () => void;
  cancelLabel?: string;
}

const AlertPopup = ({
  isShow,
  title,
  ConfirmTitle,
  modalStatus,
  closeModal,
  handleSubmit,
  remark,
  setRemark,
  loading,
  customTitle,
  width,
  display = true,
  showTaskReferenceNo = false,
  dynamicReport = false,
  icon = true,
  taskRefrenceNo,
  subTitle,
  subTitleMaxHeight,
  id = 'alertModal',
  center = false,
  showCloseButton = false,
  onClose,
  cancelLabel,
}: AlertPopupType): JSX.Element => {
  useModalScrollLock(isShow);
  const [errorMessage, setErrorMessage] = useState('');

  // useEffect(() => {
  //   if (isShow) {
  //     lockScroll();
  //   }

  //   return () => {
  //     unlockScroll();
  //   };
  // }, [isShow]);

  return (
    <Transition in={true} timeout={250}>
      {(state) => (
        <AlertPopupContainer id={id}>
          <div id='modalOverlay' className={`modalBackdrop modalBackdrop-${state}`}>
            <div id='modalContainer' className={`sideBar sideBar-${state} `}>
              <div id='modalDialog' className='popupDialog'>
                <div id='modalContent' className='popupContent'>
                  {showCloseButton && (
                    <button
                      type='button'
                      className='popupCloseButton'
                      onClick={() => {
                        if (onClose) {
                          onClose();
                        } else if (closeModal) {
                          closeModal();
                        }
                        document.getElementsByTagName('html')[0].style.overflow = 'scroll';
                      }}
                      id={`${id}CloseButton`}>
                      <span className='material-symbols-outlined'>close</span>
                    </button>
                  )}
                  <Heading
                    id='modalTitle'
                    variant='h5'
                    className={`mb-5 ${center ? 'flex justify-center' : ''}`}
                    title={
                      customTitle != null
                        ? customTitle
                        : modalStatus === 'View Remarks'
                        ? 'Rejection Reason'
                        : `Are you sure you want to ${
                            modalStatus === 'Approval'
                              ? 'approve'
                              : modalStatus === 'Reject'
                              ? 'reject'
                              : modalStatus === 'Delete'
                              ? 'delete'
                              : modalStatus === 'Deactivate'
                              ? 'deactivate'
                              : modalStatus === 'Cancel'
                              ? 'cancel'
                              : modalStatus === 'Publish'
                              ? 'publish'
                              : 'confirm'
                          } ${typeof title === 'string' ? title : ''}?`
                    }
                  />
                  {(dynamicReport || showTaskReferenceNo) && (
                    <div className='flex justify-center'>
                      <Heading
                        id='taskReference'
                        variant='h5'
                        title={`Here's the task reference number ${
                          taskRefrenceNo ? taskRefrenceNo : ''
                        }`}
                        className='font-semibold'
                      />
                    </div>
                  )}
                  {subTitle && (
                    <Heading
                      id='modalSubtitle'
                      variant='h6'
                      title={subTitle}
                      color={COLORS?.Gray}
                      className={subTitleMaxHeight ? 'scrollableContainer w-full' : 'w-full'}
                      style={subTitleMaxHeight ? { maxHeight: subTitleMaxHeight } : undefined}
                    />
                  )}
                  {(modalStatus === 'Reject' || modalStatus === 'View Remarks') && (
                    <FormWrapper>
                      <textarea
                        id='remarksField'
                        name='remarks'
                        placeholder='Enter Reason'
                        className={!isEmpty(errorMessage) ? 'border-red-600' : 'reject-view'}
                        style={{ minHeight: '100px', minWidth: '430px', resize: 'none' }}
                        {...(modalStatus === 'View Remarks'
                          ? { value: remark != null ? String(remark) : '' }
                          : { defaultValue: remark })}
                        readOnly={modalStatus === 'View Remarks'}
                        disabled={modalStatus === 'View Remarks'}
                        onChange={(e) => {
                          setRemark(e.target.value);
                          setErrorMessage('');
                        }}></textarea>
                      {errorMessage !== '' && (
                        <Heading
                          id='remarksError'
                          variant='body-xs'
                          title={'Required Field'}
                          className={'mt-2'}
                        />
                      )}
                    </FormWrapper>
                  )}
                  <div id='modalFooter' className='popupButtons'>
                    {closeModal && (
                      <Button
                        id='modalCancel'
                        variant='primary-dark'
                        type='button'
                        title={
                          cancelLabel ??
                          (dynamicReport
                            ? 'Keep Editing'
                            : display
                            ? modalStatus === 'View Remarks'
                              ? 'Close'
                              : 'No'
                            : 'Close')
                        }
                        onClick={() => {
                          closeModal();
                        }}
                      />
                    )}
                    {display
                      ? modalStatus !== 'View Remarks' && (
                          <Button
                            id='modalConfirm'
                            variant='primary'
                            title={ConfirmTitle ?? 'Confirm'}
                            onClick={() => {
                              modalStatus === 'Reject'
                                ? !isEmpty(remark)
                                  ? handleSubmit()
                                  : setErrorMessage('Required Field')
                                : handleSubmit();
                            }}
                            icon={
                              icon ? (
                                <span className='material-symbols-outlined'>check_circle</span>
                              ) : (
                                ''
                              )
                            }
                            loading={loading}
                          />
                        )
                      : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </AlertPopupContainer>
      )}
    </Transition>
  );
};

export default AlertPopup;
